import { render, staticRenderFns } from "./EcisApproval.vue?vue&type=template&id=4f6e7388&scoped=true"
import script from "./EcisApproval.vue?vue&type=script&lang=js"
export * from "./EcisApproval.vue?vue&type=script&lang=js"
import style0 from "./EcisApproval.vue?vue&type=style&index=0&id=4f6e7388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e7388",
  null
  
)

export default component.exports